const dotStyle = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: 'var(--color-orange)',
  boxShadow: '0 0 6px var(--color-orange)',
};

const NewCauseDot = ({ visible }) => {
  if (!visible) return null;
  return <div style={dotStyle} />;
};

export default NewCauseDot;
